import styled from "@emotion/styled";

export const FooterContainer = styled.footer`
  height: 20%;
  width: 100%;
  background-color: ${(props) => props.theme.colors.background};
`;
